
module.exports = require('./lib/');



/*****************
 ** WEBPACK FOOTER
 ** ./~/socket.io-client/index.js
 ** module id = 99
 ** module chunks = 7
 **/